<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openDetail="openDetail"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <el-drawer
      v-if="editFormDialogOptions.visible"
      visible
      show-close
      size="1000px"
      title="订单数据同步记录详情"
      :before-close="() => (editFormDialogOptions.visible = false)"
    >
      <edit-form ref="editForm" :syncOrderCode="editFormDialogOptions.code">
      </edit-form>
    </el-drawer>
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditForm from '../edit-form'
export default {
  components: { PageHeader, PageMain, EditForm },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      editFormDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .sysOpenapiSyncOrderListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openDetail({ syncOrderCode = '' }) {
      this.editFormDialogOptions = { visible: true, code: syncOrderCode }
    },
  },
}
</script>
